import PaidInvoicesTable from '@/components/Templates/Invoices/PaidInvoicesTable';

const PaidInvoice = () => {
	return <PaidInvoicesTable />;
};

export default PaidInvoice;